import { createTheme } from 'styled-breakpoints';

export const defaultBreakpoints = createTheme({
  mobile: '576px',
  smallTablet: '768px',
  largeTablet: '1024px',
  smallDesktop: '1350px',
  mediumDesktop: '1440px',
} as const);
